import script from "./CreateUpdateUsosSolo.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateUsosSolo.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateUsosSolo.vue?vue&type=style&index=0&id=33ac58a0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33ac58a0"]])

export default __exports__